var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyPartnerPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_17-creditcard",
    "data-name": "17-creditcard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "llinear_color",
    "data-name": "llinear color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480,6H32A26.03,26.03,0,0,0,6,32V384a26.03,26.03,0,0,0,26,26H208.671l-6.807,54.432a238.466,238.466,0,0,0-47.411,23.248A10,10,0,0,0,160,506H352a10,10,0,0,0,5.547-18.32,238.466,238.466,0,0,0-47.411-23.248L303.329,410H480a26.03,26.03,0,0,0,26-26V32A26.03,26.03,0,0,0,480,6ZM32,26H480a6.006,6.006,0,0,1,6,6V310H26V32A6.006,6.006,0,0,1,32,26ZM208,486h-6.526c15.893-6.393,35.309-12,54.526-12,19.148,0,38.556,5.607,54.459,12H208ZM289.2,458.16a134.521,134.521,0,0,0-66.39,0L228.828,410h54.344ZM486,384a6.006,6.006,0,0,1-6,6H32a6.006,6.006,0,0,1-6-6V330H486Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,370h32a10,10,0,0,0,0-20H240a10,10,0,0,0,0,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,256H311.4A73.472,73.472,0,1,0,366,127.3V86a26.029,26.029,0,0,0-26-26H108A26.029,26.029,0,0,0,82,86V230A26.029,26.029,0,0,0,108,256Zm-6-26V153H303.476a73.3,73.3,0,0,0-8.307,83H108A6.006,6.006,0,0,1,102,230Zm0-110H346v8.264A72.856,72.856,0,0,0,330.443,133H102Zm311,80.5A53.5,53.5,0,1,1,359.5,147,53.561,53.561,0,0,1,413,200.5ZM108,80H340a6.006,6.006,0,0,1,6,6v14H102V86A6.006,6.006,0,0,1,108,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,171H125a10,10,0,0,0,0,20h81a10,10,0,0,0,0-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.9,193.636a10,10,0,1,0-11.094,16.64l24,16a10,10,0,0,0,13.355-2.073l32-40a10,10,0,1,0-15.617-12.494L350.266,204.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyPartnerPayments);
export default __webpack_public_path__ + "static/media/easy_partner_payments.cd180a38.svg";
export { ForwardRef as ReactComponent };